import {
  COLORS,
  EMAIL_ENTITY_TYPE,
  EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP,
  RECIPIENT_TYPE,
} from "@miplatform/constants";
import { EmailTemplateType } from "@miplatform/types";
import {
  getAppointmentConfirmationDetails,
  getAppointmentConfirmationSubject,
  getCloseoutAndUpdateDetails,
  getCloseoutAndUpdateSubject,
  getOrderAssignmentDetails,
  getOrderAssignmentSubject,
  getOrderSandDetails,
  getOrderSandSubject,
  getTechnicianEnrouteDetails,
  getTechnicianEnrouteSubject,
} from "./util/emailFormAttemptUtil";
import {
  getOrderContactInformation,
  getRoughBuilderSandDayOneDetails,
  getRoughBuilderSandDayOneSubject,
  getRoughBuilderSandDayTwoDetails,
  getRoughBuilderSandDayTwoSubject,
  getRoughCathedralSandDayOneDetails,
  getRoughCathedralSandDayOneSubject,
  getRoughCathedralSandDayTwoDetails,
  getRoughCathedralSandDayTwoSubject,
  getTopOutDayOneDetails,
  getTopOutDayOneSubject,
  getTopOutDayTwoDetails,
  getTopOutDayTwoSubject,
  getTrimDayOneDetails,
  getTrimDayOneSubject,
  getTrimDayTwoDetails,
  getTrimDayTwoSubject,
} from "./util/emailFormOrderUtil";
import { getContactInformation } from "./util/emailFormUtil";
import {
  getAttemptEmailTemplate,
  getOrderEmailTemplate,
} from "./EmailTemplate/emailTemplateUtil";

export const DEFAULT_EMAIL_FILE_CATEGORY = "Email Correspondence";

export const EMAIL_ENTITY_TYPE_TO_TEMPLATE_MAP = {
  [EMAIL_ENTITY_TYPE.ATTEMPT]: getAttemptEmailTemplate,
  [EMAIL_ENTITY_TYPE.ORDER]: getOrderEmailTemplate,
};

const ATTEMPT_EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG = {
  [EmailTemplateType.AppointmentConfirmation]: {
    title: "Appointment Confirmation Email",
    recipient: RECIPIENT_TYPE.CUSTOMER,
    detailsLabel: "Appointment Details",
    modalDescription: "Confirm below to send the appointment details",
    color: COLORS.BLUE,
    hasArrivalWindow: true,
    toast:
      "The order has been scheduled and the email has been sent successfully.",
    getSubject: getAppointmentConfirmationSubject,
    getDetails: getAppointmentConfirmationDetails,
    getContactInformation,
    templateConfig: {
      showScheduledDate: true,
    },
  },
  [EmailTemplateType.TechnicianEnRouteNotice]: {
    title: "Technician En-Route Email",
    recipient: RECIPIENT_TYPE.CUSTOMER,
    detailsLabel: "Appointment Details",
    modalDescription: "Confirm below to send the appointment details",
    color: COLORS.BLUE,
    hasArrivalWindow: true,
    toast: "The email has been sent successfully.",
    getSubject: getTechnicianEnrouteSubject,
    getDetails: getTechnicianEnrouteDetails,
    getContactInformation,
    templateConfig: {
      showScheduledDate: true,
    },
  },
  [EmailTemplateType.OrderAssignmentNotice]: {
    title: "Order Assignment Email",
    recipient: RECIPIENT_TYPE.TECHNICIAN,
    detailsLabel: "Appointment Details",
    modalDescription: "Confirm below to send the appointment details",
    color: COLORS.ORANGE,
    hasArrivalWindow: true,
    toast: "The email has been sent successfully.",
    getSubject: getOrderAssignmentSubject,
    getDetails: getOrderAssignmentDetails,
    getContactInformation,
    templateConfig: {
      showScheduledDate: true,
    },
  },
  [EmailTemplateType.CloseoutAndCompletionNotice]: {
    title: "Closeout & Update Email",
    recipient: RECIPIENT_TYPE.CUSTOMER,
    detailsLabel: "Closeout & Order Update Details",
    modalDescription: "Confirm below to send the order update details",
    color: COLORS.BLUE,
    toast:
      "The order has been closed out and the email has been sent successfully.",
    getSubject: getCloseoutAndUpdateSubject,
    getDetails: getCloseoutAndUpdateDetails,
    getContactInformation,
    templateConfig: {
      showIssueStatus: true,
    },
  },
  [EmailTemplateType.OrderSand]: {
    title: "Sand Request",
    recipient: RECIPIENT_TYPE.VENDOR,
    detailsLabel: "Sand Request Details",
    modalDescription: "Confirm below to send sand request email",
    color: COLORS.BLUE,
    toast: "The sand request has been sent successfully.",
    getSubject: getOrderSandSubject,
    getDetails: getOrderSandDetails,
    getContactInformation,
    templateConfig: {
      showIssueStatus: true,
    },
  },
};

const ORDER_EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG = {
  [EmailTemplateType.TrimDayOne]: {
    title: EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayOne],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayOne]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayOne]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayOne]
    } email has been sent successfully.`,
    getSubject: getTrimDayOneSubject,
    getDetails: getTrimDayOneDetails,
    getContactInformation: getOrderContactInformation,
  },
  [EmailTemplateType.TrimDayTwo]: {
    title: EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayTwo],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayTwo]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayTwo]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TrimDayTwo]
    } email has been sent successfully.`,
    getSubject: getTrimDayTwoSubject,
    getDetails: getTrimDayTwoDetails,
    getContactInformation: getOrderContactInformation,
    templateConfig: {
      hideScheduledDate: true,
    },
  },
  [EmailTemplateType.TopOutDayOne]: {
    title: EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayOne],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayOne]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayOne]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayOne]
    } email has been sent successfully.`,
    getSubject: getTopOutDayOneSubject,
    getDetails: getTopOutDayOneDetails,
    getContactInformation: getOrderContactInformation,
  },
  [EmailTemplateType.TopOutDayTwo]: {
    title: EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayTwo],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayTwo]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayTwo]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.TopOutDayTwo]
    } email has been sent successfully.`,
    getSubject: getTopOutDayTwoSubject,
    getDetails: getTopOutDayTwoDetails,
    getContactInformation: getOrderContactInformation,
  },
  [EmailTemplateType.RoughBuilderSandDayOne]: {
    title:
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughBuilderSandDayOne
      ],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayOne]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayOne]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayOne]
    } email has been sent successfully.`,
    getSubject: getRoughBuilderSandDayOneSubject,
    getDetails: getRoughBuilderSandDayOneDetails,
    getContactInformation: getOrderContactInformation,
  },
  [EmailTemplateType.RoughBuilderSandDayTwo]: {
    title: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayTwo]
    }`,
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayTwo]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayTwo]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[EmailTemplateType.RoughBuilderSandDayTwo]
    } email has been sent successfully.`,
    getSubject: getRoughBuilderSandDayTwoSubject,
    getDetails: getRoughBuilderSandDayTwoDetails,
    getContactInformation: getOrderContactInformation,
  },
  [EmailTemplateType.RoughCathedralSandDayOne]: {
    title:
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayOne
      ],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayOne
      ]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayOne
      ]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayOne
      ]
    } email has been sent successfully.`,
    getSubject: getRoughCathedralSandDayOneSubject,
    getDetails: getRoughCathedralSandDayOneDetails,
    getContactInformation: getOrderContactInformation,
  },
  [EmailTemplateType.RoughCathedralSandDayTwo]: {
    title:
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayTwo
      ],
    recipient: RECIPIENT_TYPE.BUILDER,
    detailsLabel: `${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayTwo
      ]
    } Details`,
    modalDescription: `Confirm below to send ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayTwo
      ]
    } email`,
    color: COLORS.BLUE,
    toast: `The ${
      EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
        EmailTemplateType.RoughCathedralSandDayTwo
      ]
    } email has been sent successfully.`,
    getSubject: getRoughCathedralSandDayTwoSubject,
    getDetails: getRoughCathedralSandDayTwoDetails,
    getContactInformation: getOrderContactInformation,
  },
};

export const EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG = {
  ...ATTEMPT_EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG,
  ...ORDER_EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG,
};
